import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/flushed': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM344 144C299.8 144 264 179.8 264 224S299.8 304 344 304 424 268.2 424 224 388.2 144 344 144zM344 272C317.5 272 296 250.5 296 224S317.5 176 344 176 392 197.5 392 224 370.5 272 344 272zM344 200C330.7 200 320 210.7 320 224S330.7 248 344 248 368 237.3 368 224 357.3 200 344 200zM232 224C232 179.8 196.2 144 152 144S72 179.8 72 224 107.8 304 152 304 232 268.2 232 224zM152 272C125.5 272 104 250.5 104 224S125.5 176 152 176 200 197.5 200 224 178.5 272 152 272zM152 200C138.7 200 128 210.7 128 224S138.7 248 152 248 176 237.3 176 224 165.3 200 152 200zM312 344H184C170.8 344 160 354.8 160 368S170.8 392 184 392H312C325.2 392 336 381.2 336 368S325.2 344 312 344z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/flushed.js
// module id = hJ/5
// module chunks = 144